<template>
  <el-input-number
    class="base-input-number"
    :class="{ 'is-error': isError }"
    :size="size"
    :style="{ width }"
    v-bind="$attrs"
    v-on="$listeners"
  >
  </el-input-number>
</template>
<script>
export default {
  name: 'BaseInputNumber2',
  props: {
    size: {
      type: String,
      default: 'small'
    },
    width: {
      type: String,
      default: '200px'
    },
    isError: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>

$--font-size-base: 14px;
$--input-border-color: #E1E1E1;

.base-input-number {
  ::v-deep {
    .el-input {
      font-size: $--font-size-base;
    }
    .el-input__inner,
    .el-textarea__inner {
      border-radius: $--border-radius-base2;
      border-color: $--input-border-color;
      &:hover {
        border-color: $--input-border-color-hover;
      }
      &:focus {
        border-color: $--input-border-color-focus !important;
      }
    }
    .el-input-number__decrease {
      border-radius: $--border-radius-base2 0 0 $--border-radius-base2;
    }
    .el-input-number__increase {
      border-radius: 0 $--border-radius-base2 $--border-radius-base2 0;
    }
    .el-input-number__decrease:hover, 
    .el-input-number__increase:hover {
      color: $--input-border-color-focus !important;
    }
    .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled),
    .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled) {
      border-color: $--input-border-color-focus !important;
    }
  }

  &.is-error {
    ::v-deep {
      .el-input__inner,
      .el-textarea__inner {
        border-color: $--color-danger;
      }
    }
  }
}
</style>